import Button from '@/components/ui/Button';
import PropTypes from 'prop-types';

const HeroSection = ({ title, description, primaryCTA, secondaryCTA }) => {
  return (
    <section className="relative bg-[#f7fbff] overflow-hidden hero-section-spacing min-h-[70vh]">
      {/* Background Pattern */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/images/hero-background.webp')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>
      <div className="absolute inset-0 bg-black opacity-45 z-0"></div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-20 relative z-10 flex items-center min-h-[70vh]">
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-10 items-center w-full">
          <div className="text-left px-4 sm:px-8 mr-0 lg:mr-20">
            <h1
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-tight mb-6 sm:mb-8"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {title}
            </h1>

            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white mb-8 max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl">
              {description}
            </p>

            <div className="flex flex-col sm:flex-row justify-start gap-4">
              {secondaryCTA && (
                <Button
                  variant="gold-outline"
                  size="large"
                  className="shadow-md hover:shadow-lg"
                  rounded
                  onClick={secondaryCTA.onClick}
                >
                  {secondaryCTA.icon && (
                    <img src={secondaryCTA.icon} alt="" className="mr-3 h-5 w-5 sm:h-6 sm:w-6" />
                  )}
                  {secondaryCTA.text}
                </Button>
              )}
              {primaryCTA && (
                <Button variant="gold" size="large" rounded onClick={primaryCTA.onClick}>
                  {primaryCTA.text}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

HeroSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  primaryCTA: PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  }),
  secondaryCTA: PropTypes.shape({
    text: PropTypes.string.isRequired,
    icon: PropTypes.string,
    onClick: PropTypes.func,
  }),
};

export default HeroSection;
